import { getListBrowserStore } from '@ts-private/list-browser';

export const citiesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'code',
      caption: 'City.Code',
      type: 'text'
    },
    {
      name: 'name',
      caption: 'City.Name',
      type: 'text'
    },
    {
      name: 'type',
      caption: 'City.Type',
      type: 'select',
      underlyingType: 'number'
    },
    {
      name: 'inactive',
      caption: 'City.Inactive',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'City.Name',
      value: 'CityName'
    },
    {
      caption: 'City.Code',
      value: 'CityCode'
    }
  ],
  pager: {
    orderBy: 'CityName',
    direction: 'asc'
  }
});
